import React, { useState, useEffect, Fragment } from "react";
import Breadcrumb from "../../components/common/breadcrumb";
import axiosConfig from "../../services/axiosConfig";
import setHeader from "../../components/Functions/setHeader";
import NoDataHandler from "../../components/common/NoDataHandler";
import LoadingComponent from "../../components/common/LoadingComponent";
import { useNavigate, useParams } from "react-router-dom";

const PurchaseDetails = () => {
    const { id } = useParams()
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState([]);
    const navigate = useNavigate()


    useEffect(() => {
        getData();
    }, []);


    const getData = () => {
        setLoading(true);
        setData([]); // Reset data before fetching new data
        axiosConfig.get(`get-purchase/${id}`, setHeader())
            .then((res) => {
                setData(res.data.data);
            })
            .catch((error) => {
                console.error("Error fetching data:", error);
            })
            .finally(() => {
                setLoading(false);
            });
    };

const formatDate = (dateString) => {
  if (!dateString) return '';
  const date = new Date(dateString);
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = String(date.getFullYear()).slice(-2);
  return `${day}-${month}-${year}`;
};

    if (loading) {
        return (
            <LoadingComponent />
        );
    }

    return (
        <Fragment>
            <Breadcrumb title="Purchase Details" parent="Purchase" />
            <div className="container-fluid">
                <div className="row">
                    {/* Data Table */}
                    <div className="col-sm-12">
                        <div className="card">
                            <div className="card-header">
                               <h5>Purchase Details at Date ({formatDate(data?.purchase_date)})</h5>
                            </div>
                            <div className="card-body">
                                {data?.length === 0 ? (
                                    <NoDataHandler title='No Purchases Found' />
                                ) : (
                                    <div className="table-responsive">
                                        <table className="table">
                                            <thead>
                                                <tr>
                                                    <th scope="col">{"#"}</th>
                                                    <th scope="col">{"Product Name"}</th>
                                                    <th scope="col">{"Qty"}</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {data?.products?.map((item, index) => {
                                                    return (
                                                        <tr key={item.purchase_id}>
                                                            <th scope="row">{index + 1}</th>
                                                            <td>{item.productName}</td>
                                                            <td>{item.qty}</td>
                                                        </tr>
                                                    );
                                                })}
                                            </tbody>
                                        </table>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                    <button className="btn btn-primary" onClick={() => navigate(-1)}>Back</button>
                </div>
            </div>
        </Fragment>
    );
};

export default PurchaseDetails;